export default {"src":"/_next/static/media/btcIcon.6c18e5eb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};